/* eslint-disable jsx-a11y/role-has-required-aria-props */
import React from 'react';
import { Icon } from '@cb/apricot-react-icon';
export const DropdownItem = ({ label, value, icon, onClickDropdownItem }) => {
    return (React.createElement("li", { role: "presentation" },
        React.createElement("a", { href: "/#", role: "option", onClick: e => {
                e.preventDefault();
                onClickDropdownItem && onClickDropdownItem(e, label, value);
            }, onKeyDown: e => {
                onClickDropdownItem && onClickDropdownItem(e, label, value);
            } },
            React.createElement("span", null, label),
            icon && React.createElement(Icon, { name: icon, decorative: true }))));
};
//# sourceMappingURL=DropdownItem.js.map